import { Button, Text } from '@elladx/design-system';
import { Trash2 } from 'lucide-react';
import Modal from './Modal';
interface BulkDeleteModalProps {
    isOpen: boolean;
    count: number;
    deleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
}
function BulkDeleteModal({ isOpen, count, deleting, onClose, onConfirm }: BulkDeleteModalProps) {
    return (<Modal isOpen={isOpen} onClose={onClose} title="Delete Selected Addresses" dismissible={!deleting}>
      <Text style={{ marginBottom: '20px' }}>
        Are you sure you want to delete {count} address{count !== 1 ? 'es' : ''}? This action cannot be undone.
      </Text>
      <div className="dialog-actions">
        <Button onClick={onClose} disabled={deleting} variant="ghost" type="submit">
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={deleting || count === 0} variant="danger-secondary" type="submit" isLoading={deleting}>
          <Trash2 size={16}/>
          {deleting ? 'Deleting...' : `Delete ${count}`}
        </Button>
      </div>
    </Modal>);
}
export default BulkDeleteModal;
